import * as React from 'react';

import LogoIcon from 'assets/images/logo-icon.png';
import Logo from 'assets/images/logo.png';
import { AntdRouterLink, LazyLoadImage } from 'components';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    HOME: { BASE_URL: HOME_BASE_URL },
  },
} = PATHNAME;

type LogoProps = Partial<
  Pick<React.ComponentPropsWithoutRef<typeof AntdRouterLink>, 'to'> &
    React.ComponentPropsWithoutRef<typeof LazyLoadImage>
>;

const ExpandedLogo = React.forwardRef<
  React.ElementRef<typeof AntdRouterLink>,
  LogoProps
>(
  (
    {
      to = HOME_BASE_URL,
      src = Logo,
      width = 135,
      height = 35,
      alt = 'کاشی لند',
      ...props
    },
    ref,
  ) => (
    <AntdRouterLink ref={ref} to={to}>
      <LazyLoadImage
        src={src}
        width={width}
        height={height}
        alt={alt}
        {...props}
      />
    </AntdRouterLink>
  ),
);
ExpandedLogo.displayName = 'ExpandedLogo';

const CompactLogo = React.forwardRef<
  React.ElementRef<typeof AntdRouterLink>,
  LogoProps
>(
  (
    {
      to = HOME_BASE_URL,
      src = LogoIcon,
      width = 40,
      height = 15,
      alt = 'کاشی لند',
      ...props
    },
    ref,
  ) => (
    <AntdRouterLink ref={ref} to={to}>
      <LazyLoadImage
        src={src}
        width={width}
        height={height}
        alt={alt}
        {...props}
      />
    </AntdRouterLink>
  ),
);
CompactLogo.displayName = 'CompactLogo';

export { CompactLogo, ExpandedLogo };
